import React from "react";
import PropTypes from "prop-types";
import BaseGameActionButton from "../../../../components/GameActionButtons";
import models from "../../../../types/models";
import { observer } from "mobx-react-lite";
import "./style.scss";

export default observer(function SwiperActions({
  countCard,
  isSwiping,
  isToRight,
  isNegative,
  isNeutral,
  isToTop,
  isToLeft,
  isPositive,
  backSwipe,
  positiveSwipe,
  neutralSwipe,
  selectedCard,
  negativeSwipe,
  isAnsweredCardsExist,
  forwardSwipe,
  card,
  completedCards,
}) {
  SwiperActions.propTypes = {
    countCard: PropTypes.number,
    isSwiping: PropTypes.bool,
    isToRight: PropTypes.bool,
    isNegative: PropTypes.bool,
    isNeutral: PropTypes.bool,
    isToTop: PropTypes.bool,
    isToLeft: PropTypes.bool,
    isPositive: PropTypes.bool,
    backSwipe: PropTypes.func,
    positiveSwipe: PropTypes.func,
    neutralSwipe: PropTypes.func,
    negativeSwipe: PropTypes.func,
    isAnsweredCardsExist: PropTypes.func,
    forwardSwipe: PropTypes.func,
    selectedCard: PropTypes.object,
    card: PropTypes.oneOfType([models.gameCard, models.compromiseGameCard]),
    completedCards: PropTypes.array,
  };
  return (
    <div className="in-game-page__main__swipe-wrapper__wrapper__actions">
      <BaseGameActionButton
        className="in-game-page__main__swipe-wrapper__wrapper__actions__action"
        disabled={countCard <= 0 || isSwiping}
        onClick={() => backSwipe(card)}
        type="back"
      />
      <BaseGameActionButton
        className={`in-game-page__main__swipe-wrapper__wrapper__actions__action`}
        disabled={isToRight || isToTop || isPositive || isNeutral}
        onClick={() => negativeSwipe(card)}
        isNegative={isToLeft}
        type="negative"
        prevAnswer={
          selectedCard ? selectedCard.answer : completedCards[countCard]?.answer
        }
      />
      <BaseGameActionButton
        className={`in-game-page__main__swipe-wrapper__wrapper__actions__action`}
        disabled={isToLeft || isToRight || isPositive || isNegative}
        onClick={() => neutralSwipe(card)}
        isNeutral={isToTop}
        type="question"
        prevAnswer={
          selectedCard ? selectedCard.answer : completedCards[countCard]?.answer
        }
      />
      <BaseGameActionButton
        className={`in-game-page__main__swipe-wrapper__wrapper__actions__action`}
        disabled={isToLeft || isNegative || isNeutral || isToTop}
        onClick={() => positiveSwipe(card)}
        isPositive={isToRight}
        type="positive"
        prevAnswer={
          selectedCard ? selectedCard.answer : completedCards[countCard]?.answer
        }
      />
      <BaseGameActionButton
        className="in-game-page__main__swipe-wrapper__wrapper__actions__action"
        disabled={
          countCard === completedCards.length - 1 ||
          isSwiping ||
          !completedCards.length
        }
        onClick={() => forwardSwipe(card, completedCards.length)}
        type="forward"
      />
    </div>
  );
});
